import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SelectorDecadaTorneo from "./SelectorDecadaTorneo.js";
import CuadroDatos from "../UI/CuadroDatos.js";
import IconoMovimiento from "../UI/IconoMovimiento.js";
import IconoTitulo from "../UI/IconoTitulo.js";
import TablaDatos from "../UI/TablaDatos.js";
import { Categoria } from "../constantes/Parametros.js";
import { TorneoEnDecada } from "../funciones/FuncionesTorneos.js";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import styles from "./TorneosClub.module.css";

const TorneosClub = (props) => {
  const [torneos, setTorneos] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const [decadaElegida, setDecadaElegida] = useState(null);
  const idClub = props.club && props.club.id;
  const [categoria, setCategoria] = useState(Categoria.MAYOR);

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idClub !== null) {
      fetchData("clubes/" + idClub + "/torneos?categoria=" + categoria.codigo, setTorneos);
    } else {
      setTorneos(null);
    }
  }, [fetchData, idClub, categoria]);

  const mostrarTorneo = (torneo) => {
    if (decadaElegida == null) {
      return true;
    } else {
      return TorneoEnDecada(torneo, decadaElegida);
    }
  }

  return (
    <CuadroDatos titulo="Participaciones en torneos" isCargando={isCargando} errores={erroresGetLista}>
      <SelectorDecadaTorneo torneos={torneos} onDecadaElegida={setDecadaElegida} />
      {torneos && !isCargando && (
        <TablaDatos
          estilo={`${styles.tablaDatos}`}
          lista={torneos}
          textoVacia="El club no participó en ningún torneo"
        >
          <tbody>
            <tr key="0">
              <td>Torneo</td>
              <td>Equipo</td>
              <td>Tipo</td>
            </tr>
            {torneos.map((torneo, index) => (
              mostrarTorneo(torneo) && (
                <tr key={index}>
                  <td className={`${styles.valor}`} key={index}>
                    <Link
                      to={"/torneos/" + torneo.id + (torneo.equipo ? "/equipo/" + torneo.equipo.codigo : "")}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {torneo.descripcion}
                    </Link>
                    <IconoTitulo objeto={torneo} />
                    <IconoMovimiento objeto={torneo} />
                  </td>
                  <td className={`${styles.valor}`} key={"E"+index}>{torneo.equipo && torneo.equipo.nombre}</td>
                  <td className={`${styles.valor}`} key={"T"+index}>{torneo.tipoTorneo && torneo.tipoTorneo.nombre}</td>
                </tr>
              )
            ))}
          </tbody>
        </TablaDatos>
      )}
    </CuadroDatos>
  );
};

export default TorneosClub;
